import * as Yup from "yup";

const CodeValidation = Yup.object().shape({
  code: Yup.string()
    .min(8, "Must have 8 characters")
    .max(8, "Cannot have more than 8 characters")
    // .matches(
    //     /^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{5,}$/,
    //     "Must Contain 5 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    // )
    .required("Must have 8 characters"),
  playerName: Yup.string()
    .min(3, "Must have 8 characters")
    .max(10, "Cannot have more than 10 characters")
    // .matches(
    //     /^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{5,}$/,
    //     "Must Contain 5 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    // )
    .required("Must have 3-10 characters"),
});

export default CodeValidation;

export const AdminCodeValidation = Yup.object().shape({
  code: Yup.string()
});

 export interface IAdminLoginDefaultValues{
  code:string;
}

export const AdminDefaultValues:IAdminLoginDefaultValues= {
  code: ""
}